export const deepCompare = (a: string[], b: string[]): boolean =>
  a.length === b.length && a.every((value) => b.includes(value));

export const deepOrderedCompare = (a: string[], b: string[]): boolean =>
  a.length === b.length && a.every((value, index) => b[index] === value);
